// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"basket-amount-visuallyHidden--aeac0","icon":"basket-amount-icon--c2f1a","icon__bp":"basket-amount-icon__bp--0c366"};